export default class Utils {
  static hoverBorder(isEditing, style = {}) {
    const base = {
      border: isEditing ? '1px dashed lightGray' : '1px dashed rgb(0,0,0,0)',
      boxShadow: 'none',
      position: 'relative',
      '&:hover': {
        border: isEditing ? '1px dashed blue' : '1px dashed rgb(0,0,0,0)',
        boxShadow: isEditing ? '0px 5px 7px rgb(0,0,0,0.3)' : 'none',
      },
    };
    return { ...base, ...style };
  }
  static moveArrayItem(array, from, to) {
    if ((from === 0 && to === -1) || (from === (array.length - 1) && to === array.length)) return array;
    const newArray = array.slice();
    const item = newArray.splice(from, 1)[0];
    newArray.splice(to, 0, item);
    return newArray;
  }
}
